"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
function _templateObject() {
    var data = _taggedTemplateLiteralLoose([""]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) {
    raw = strings.slice(0);
} strings.raw = raw; return strings; }
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const Entry_1 = __importDefault(require("./Entry"));
var SectionStyledWork = styled_1.default.section(_templateObject());
var SectionWork = function SectionWork(_ref) {
    var work = _ref.work;
    return /*#__PURE__*/ react_1.default.createElement(SectionStyledWork, null, /*#__PURE__*/ react_1.default.createElement("h2", null, "Work"), work.map(function (w, i) {
        return /*#__PURE__*/ react_1.default.createElement(Entry_1.default, Object.assign({
            key: w.title + i
        }, w));
    }));
};
exports.default = SectionWork;
